module.exports = __webpack_public_path__ + "static/media/Global-Biotechnology-Congress-2017.02b38628.jpg";